var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2723 21.4308C18.1889 21.4308 16.1306 20.9766 14.0973 20.0683C12.0639 19.16 10.2139 17.8725 8.54727 16.2058C6.8806 14.5391 5.5931 12.6891 4.68477 10.6558C3.77643 8.62245 3.32227 6.56412 3.32227 4.48079C3.32227 4.18079 3.42227 3.93079 3.62227 3.73079C3.82227 3.53079 4.07227 3.43079 4.37227 3.43079H8.42227C8.6556 3.43079 8.86393 3.50995 9.04727 3.66829C9.2306 3.82662 9.33893 4.01412 9.37226 4.23079L10.0223 7.73079C10.0556 7.99745 10.0473 8.22245 9.99726 8.40579C9.94727 8.58912 9.8556 8.74745 9.72226 8.88079L7.29727 11.3308C7.6306 11.9475 8.02643 12.5433 8.48477 13.1183C8.9431 13.6933 9.44727 14.2475 9.99726 14.7808C10.5139 15.2975 11.0556 15.7766 11.6223 16.2183C12.1889 16.66 12.7889 17.0641 13.4223 17.4308L15.7723 15.0808C15.9223 14.9308 16.1181 14.8183 16.3598 14.7433C16.6014 14.6683 16.8389 14.6475 17.0723 14.6808L20.5223 15.3808C20.7556 15.4475 20.9473 15.5683 21.0973 15.7433C21.2473 15.9183 21.3223 16.1141 21.3223 16.3308V20.3808C21.3223 20.6808 21.2223 20.9308 21.0223 21.1308C20.8223 21.3308 20.5723 21.4308 20.2723 21.4308Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIc);
export default __webpack_public_path__ + "static/media/call_ic.2df3da7f3a2210de11dac93e36fd687f.svg";
export { ForwardRef as ReactComponent };